import { NOTIFICATIONS_SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

const notificationPublicUrl = `${NOTIFICATIONS_SERVER_API}`;

export default {
  LIST: {
    method: 'GET',
    url: `${notificationPublicUrl}/updates`,
  } as IEndpointData,
  GET(id: string): IEndpointData {
    return {
      method: 'GET',
      url: `${notificationPublicUrl}/${id}`,
    };
  },
  MARK_READ: {
    method: 'POST',
    url: `${notificationPublicUrl}/updates/mark`,
  } as IEndpointData,
  MARK_ALL_READ: {
    method: 'POST',
    url: `${notificationPublicUrl}/updates/mark/all`,
  } as IEndpointData,
  REGISTER_SUBSCRIPTION: {
    method: 'POST',
    url: `${notificationPublicUrl}/web-push/subscriptions`,
  } as IEndpointData,
};
